import axiosClient from './axiosClient';

const rideReviewApi = {
  // "Khách -> Tài xế": the review a customer left about the driver.
  getDriverReviews: (params) => axiosClient.get('/rides/reviews', { params }),
  getDriverReview: (reviewId) => axiosClient.get(`/rides/reviews/${reviewId}`),
  removeDriverReview: (reviewId) => axiosClient.delete(`/rides/reviews/${reviewId}`),

  // "Tài xế -> Khách": the review a driver left about the customer.
  getCustomerReviews: (params) => axiosClient.get('/rides/customer-reviews', { params }),
  getCustomerReview: (reviewId) => axiosClient.get(`/rides/customer-reviews/${reviewId}`),
  removeCustomerReview: (reviewId) => axiosClient.delete(`/rides/customer-reviews/${reviewId}`),
};

export default rideReviewApi;
